import React from 'react';
import DevErrorDisplay from './DevErrorDisplay';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Actualiza el estado para que el siguiente render muestre la UI de fallback
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Captura cualquier error en el árbol de componentes
    console.error('Error Boundary caught an error:', error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      // En desarrollo, mostrar el error detallado
      if (process.env.NODE_ENV === 'development') {
        return <DevErrorDisplay error={this.state.error} errorInfo={this.state.errorInfo} />;
      }
      
      // En producción, mostrar un mensaje simple
      return (
        <div style={{
          padding: '20px',
          margin: '20px',
          border: '2px solid #ff6b6b',
          borderRadius: '8px',
          backgroundColor: '#fff5f5',
          fontFamily: 'monospace'
        }}>
          <h2 style={{ color: '#d63031', marginBottom: '10px' }}>
            🚨 Error en el Componente
          </h2>
          <div style={{ marginBottom: '15px' }}>
            <strong>Error:</strong> {this.state.error && this.state.error.toString()}
          </div>
          {this.state.errorInfo && (
            <details style={{ marginBottom: '15px' }}>
              <summary style={{ cursor: 'pointer', color: '#2d3436' }}>
                <strong>Stack Trace:</strong>
              </summary>
              <pre style={{
                backgroundColor: '#f8f9fa',
                padding: '10px',
                borderRadius: '4px',
                overflow: 'auto',
                fontSize: '12px',
                marginTop: '10px'
              }}>
                {this.state.errorInfo.componentStack}
              </pre>
            </details>
          )}
          <button
            onClick={() => window.location.reload()}
            style={{
              backgroundColor: '#74b9ff',
              color: 'white',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            Recargar Página
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
